import { render } from "./ThanksForReview.vue?vue&type=template&id=45e45283&scoped=true"
import script from "./ThanksForReview.vue?vue&type=script&lang=js"
export * from "./ThanksForReview.vue?vue&type=script&lang=js"

import "./ThanksForReview.vue?vue&type=style&index=0&id=45e45283&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e45283"]])

export default __exports__